import { render, staticRenderFns } from "./EditType.vue?vue&type=template&id=19b05750&"
import script from "./EditType.vue?vue&type=script&lang=ts&"
export * from "./EditType.vue?vue&type=script&lang=ts&"
import style0 from "./EditType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports